import React from 'react';
import { StyleSheet, Text, View } from './components/base_components';

import WideButton from './components/buttons/wide_button';

const styles = StyleSheet.create({
  notFoundScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    margin: '2em',
    alignSelf: 'stretch',
    color: 'white',
    fontSize: '2em',
    textAlign: 'center',
  },
  button: {
    marginTop: '5em',
  },
});

type Props = {};
type State = {};

export default class NotFoundScreen extends React.PureComponent<Props, State> {
  _onHomePress = () => this.props.history.replace('/');

  render() {
    return (
      <View style={styles.notFoundScreen}>
        <Text style={styles.text}>Aliens have eliminated this page.</Text>
        <WideButton
          style={styles.button}
          text='Escape!'
          onPress={this._onHomePress}
        />
      </View>
    );
  }
}
